module.exports = __webpack_public_path__ + "static/media/stove.09a8f3b5.gif";